import { render, staticRenderFns } from "./WeeklyViewDraggable.vue?vue&type=template&id=4ed0a409&scoped=true"
import script from "./WeeklyViewDraggable.vue?vue&type=script&lang=js"
export * from "./WeeklyViewDraggable.vue?vue&type=script&lang=js"
import style0 from "./WeeklyViewDraggable.vue?vue&type=style&index=0&id=4ed0a409&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed0a409",
  null
  
)

export default component.exports